<template>
  <nav class="header" id="header">
    <router-link class="header-logo" to="/">
      <h1 class="title">Home</h1>
    </router-link>
    <div class="right-header">
      <div><router-link class="navbar-item" to="/tickets">Tickets</router-link></div>
      <div><router-link class="navbar-item" to="/profile">Devices</router-link></div>
    </div>
  </nav>
  <router-view />
  <Chat :chat="messages" :onSend="handleMessage" bgColorIcon="rgb(81, 201, 131)" bgColorMessagePerson="rgb(81, 201, 131)" />
</template>

<script>
import { Chat } from "@chat-ui/vue3";

export default {
  name: 'App',
  components: {
    Chat
  },
  data() {
    return {
      messages: []
    }
  },
  methods: {
    formatTime() {
      const now = new Date();
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const minutesStr = minutes < 10 ? '0' + minutes : minutes;

      const timeStr = hours + ':' + minutesStr + ' ' + ampm;
      return timeStr;
    },
    handleMessage(message) {
      this.messages.push({ message: message, type: 'person', timestamp: this.formatTime() })
    }
  }
}
</script>

<style>
* {
  font-family: 'Work Sans', sans-serif;
}

a {
  text-decoration: none;
  color: black;
  transition: all 0.25s;
}

a:hover {
  color: rgb(81, 201, 131);
}

body {
  margin: 0;
  height: 100%;
}

html,
#app {
  height: 100%;
}

.header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  box-shadow: 1px 11px 16px 1px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 1px 11px 16px 1px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 1px 11px 16px 1px rgba(0, 0, 0, 0.15);
  margin: 0;
  height: 8%;
}

.right-header {
  display: flex;
  align-items: center;
  margin-right: 6%;
  width: 20%;
  justify-content: space-evenly;
}

.header-logo {
  margin-left: 6%;
  display: flex;
  align-items: center;
}
</style>
